import { useState } from 'react';
import { SCREENSHOT_BASE, type Screenshot } from '../lib/screenshots';

/**
 * Polished browser-chrome frame for product screenshots on the marketing
 * homepage. Renders `/media/screenshots/<file>` and falls back to an
 * elegant gradient panel carrying the page label while the real capture
 * is missing — so the section looks intentional before the screenshot
 * pass lands, and real screenshots appear automatically once dropped in
 * (no code change required).
 */
export function BrowserFrame({ shot, wide }: { shot: Screenshot; wide?: boolean }) {
  const [failed, setFailed] = useState(false);

  return (
    <figure className={`lp-shot${wide ? ' lp-shot-wide' : ''}`}>
      <div className="lp-shot-chrome" aria-hidden="true">
        <span className="lp-shot-traffic"><i /><i /><i /></span>
        <span className="lp-shot-url">https://grantrfpnavigator.tech{shot.url}</span>
      </div>
      {failed ? (
        <div className="lp-shot-fallback" role="img" aria-label={`${shot.label} preview`}>
          <span className="lp-shot-fallback-label">{shot.label}</span>
        </div>
      ) : (
        <img
          src={`${SCREENSHOT_BASE}/${shot.file}`}
          alt={`${shot.label} — product screenshot`}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      )}
      <figcaption className="lp-shot-caption">{shot.label}</figcaption>
    </figure>
  );
}
